import { connect } from "react-redux";
import RequestTransactionDetails from "./RequestTransactionList";
import { bindActionCreators } from "redux";
import {requesttransactionList} from "../../../services/redux/Wallet/action";
const mapStateToProps = (state) => ({
    requestById : state.Wallet.requestById,
    approvalListDetails : state.Wallet.approvlListData,
    requesttransactionListDetails : state.Wallet.requesttransactionlisting,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        requesttransactionList,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RequestTransactionDetails);